// In-app browsers. Facebook, Instagram, Messenger, TikTok and friends open
// links inside their own webview, and Google refuses to run sign-in there
// ("disallowed_useragent"). Two-thirds of our ad traffic arrives this way,
// so the sign-up modal has to know, and lead with a path that works.

const PATTERNS = [
  ["facebook", /FBAN|FBAV|FB_IAB|FBIOS|FB4A|FBBV/],
  ["messenger", /Messenger|FBMSG/i],
  ["instagram", /Instagram/i],
  ["tiktok", /TikTok|musical_ly|Bytedance/i],
  ["linkedin", /LinkedInApp/i],
  ["snapchat", /Snapchat/i],
  ["twitter", /Twitter|X-Client/i],
];

export const detectInAppBrowser = (ua) => {
  const s = String(ua === undefined ? (typeof navigator !== "undefined" ? navigator.userAgent : "") : ua);
  const hit = PATTERNS.find(([, re]) => re.test(s));
  return hit ? hit[0] : null;
};

export const isIOS = (ua) => /iPhone|iPad|iPod/.test(String(ua === undefined ? (typeof navigator !== "undefined" ? navigator.userAgent : "") : ua));
export const isAndroid = (ua) => /Android/.test(String(ua === undefined ? (typeof navigator !== "undefined" ? navigator.userAgent : "") : ua));

// Android webviews honour an intent: URL that hands the page to Chrome.
// iOS has no equivalent a page can trigger; the person has to use the
// in-app menu, so we tell them exactly where it is.
export const openInBrowserHref = (url) => {
  if (!isAndroid()) return null;
  const u = new URL(url, typeof window !== "undefined" ? window.location.href : "https://app.swyvel.io");
  return `intent://${u.host}${u.pathname}${u.search}#Intent;scheme=https;package=com.android.chrome;end`;
};

export const openInBrowserHint = () =>
  isIOS() ? "Tap the ··· menu at the corner, then Open in Safari." : "Tap the ⋮ menu, then Open in Chrome.";
